import { Box, Button, Heading, Text, Flex } from '@chakra-ui/react'
import MuiIcon from 'components/MuiIcon';
import { useTranslation } from 'react-i18next';
import {
  useActivateOneUser,
  useDeactivateOneUser,
  useGetUsers,
  useDeleteUser,
  useRestoreUser,
} from "shared/api/requests/users";
import { UsersT } from 'shared/api/types/users';
import Card from 'shared/components/horizon-ui/card/Card';
import Link from 'shared/components/Link';
import InfiniteTable from 'shared/components/table/InfiniteTable';
import useGetColors from 'shared/hooks/useGetColors';
import { LayoutsE, PathsE } from 'shared/routes';
import PageTitle from '../admin/PageTitle';
import { useGetColumns, useGetFilterFields, useGetGetBreadcrumbs } from './constants';
import { TableNameE } from 'shared/api/types/common';

const Index = () => {
  const { t } = useTranslation();
  const { blue800 } = useGetColors();
  const { mutate: activateMutation } = useActivateOneUser();
  const { mutate: deactivateMutation } = useDeactivateOneUser();
  const { mutate: deleteMutation } = useDeleteUser();
  const { mutate: restoreMutation } = useRestoreUser();
  const handleActivate = (id: string) => activateMutation({ id });
  const handleDeactivate = (id: string) => deactivateMutation({ id });
  const handleDelete = (userId: string) => deleteMutation({ userId });
  const handleRestore = (userId: string) => restoreMutation({ userId });

  const columns = useGetColumns({
    handleActivate,
    handleDeactivate,
    handleDelete,
    handleRestore,
  });
  const breadcrumbs = useGetGetBreadcrumbs();
  const filterFields = useGetFilterFields();

  return (
    <Box>
      <PageTitle title={t('users.users')} breadcrumbs={breadcrumbs}/>
      <Card mb="20px" borderRadius="20px" px="30px">
        <Flex alignItems="center">
          <Heading size="md" color={blue800}>
            {t('users.usersTable')}
          </Heading>
          <Link layout={LayoutsE.DASHBOARD} path={PathsE.CREATE_USER}>
            <Button
              fontSize="16px"
              ml="20px"
              color="white"
              backgroundColor="brand.500"
              fontWeight="600"
              _hover={{
                backgroundColor: "brand.400"
              }}
              paddingY="8px"
              display="flex"
              borderRadius="8px"
              alignItems="center"
            >
              <MuiIcon name="add" size={24} color="gray800" variant="rounded" />
              <Text ml="8px">{t('users.user')}</Text>
            </Button>
          </Link>
        </Flex>
        <InfiniteTable<UsersT>
          query={useGetUsers}
          columns={columns}
          filterFields={filterFields}
          tableName={TableNameE.USERS}
        />
      </Card>
    </Box>
  );
};

export default Index;
